<template>
    <section>
        <checkout-form />
    </section>
</template>

<script>
    import CheckoutForm from "./CheckoutForm";
    export default {
        name: "CheckoutComponent",
        components: {
            CheckoutForm
        }
    };
</script>

<style scoped></style>
